import { Column } from "../../../../core/components/Column";
import { TextComponent } from "../../../../core/components/TextComponent";

export const PrivacyPolicy = () => {
    return (
        <Column className="gap-5">
            <Column className="gap-5">
                <TextComponent variant="h5">
                    Please read our Privacy Policy carefully as it explains the following:
                </TextComponent>
                <TextComponent variant="h5">
                    In order to use the App, you must first acknowledge and agree to our Privacy Policy. You cannot use the App without first accepting our Privacy Policy.
                </TextComponent>
            </Column>
            <Column className="gap-5">
                <TextComponent variant="h5">GENERAL</TextComponent>
                <TextComponent variant="h5">
                    We provide the Unjabbed Application. Unjabbed recognizes and understands the importance of the privacy of its users and wants to respect their desire to store and access personal information in a private and secure manner. This Privacy Policy applies to our application and describes how we manage, store, and utilize your Personal Data through its Products.
                </TextComponent>
                <TextComponent variant="h5">
                    In order to use our app, we require you to consent to the collection and processing of your Personal Data before you start using the app. If you do not agree with the terms of this Privacy Policy, you may not use in any manner the app.
                </TextComponent>
                <TextComponent variant="h5">
                    We are committed to protecting the privacy of all of its users’ Personal Data and providing a secure, user-controlled environment for the use of the app.
                </TextComponent>
            </Column>
            <Column className="gap-5">
                <TextComponent variant="h5">PERSONAL DATA YOU PROVIDE</TextComponent>
                <ul>
                    <li>
                        <TextComponent variant="h5">
                            Affiliate Program Information. If you join, apply for, share, click, or sign up through the affiliate program, we may collect and use affiliate profile details, affiliate code, link activity, referral source, device/browser information, IP address, signup attribution, subscription activity, PayPal payout email, payout setup status, commission history, payout history, fraud-prevention notes, safety holds, admin notes, and related audit records. We use this information to track referrals, calculate eligible commissions, prevent self-referrals and abuse, manage payout holds, meet payout and tax obligations where applicable, resolve disputes, and keep the program safe. If payout setup is available, PayPal or another approved payout provider may collect identity, tax, bank, or payment-account details under its own terms and privacy rules. Unjabbed should not store affiliate bank details directly inside the app.
                        </TextComponent>
                    </li>
                    <li>
                        <TextComponent variant="h5">
                            Account Credentials. In order to use the Unjabbed App Services and account registration, you age must be 18 years old or above. Each member is required to login with an Account Authentication Mechanism (Name, and email Address, or any third -partly login such as Google Sign-in, Facebook Sign-in, Apple Sign-in) When creating an account, Unjabbed stores a hashed version of your Account Authentication Mechanism for authentication and/or verification purposes. We use a third-party service provider for verification and authentication.
                            Profile Information. When you create a Unjabbed account, you choose to provide us with Personal Data about yourself. For example, in the Unjabbed App, you may provide your Personal Data, such as name, email address, and any other information that is required to positively identify the user.
                        </TextComponent>
                    </li>
                    <li>
                        <TextComponent variant="h5">
                            Profile Information. When you create an account, you choose to provide us with Personal Data about yourself. For example, in the Unjabbed App, you may provide your Personal Data, such as name, email address, and any other information that is required to positively identify the user.
                        </TextComponent>
                    </li>
                    <li>
                        <TextComponent variant="h5">
                            Photos, Videos and Audio. If you upload a photo or video, while using the Unjabbed App Services, you will be required to permit Unjabbed to access your camera, photo gallery, and microphone in which case Unjabbed will have access to the photos and videos stored in your photo gallery.
                        </TextComponent>
                    </li>
                    <li>
                        <TextComponent variant="h5">
                            Location and Distance Information. When you use the Unjabbed App, we collect your precise location (e.g. your latitude and longitude) (“Location”) to determine distance in feet or meters (“Distance Information”). Should you choose not to allow the Unjabbed App to access your Location, certain features (such as displaying nearby user profiles or features that include Live Location Sharing) of the Unjabbed Services will not function properly. You may also revoke this permission and disable the location services on your device. You can do so on an iPhone by going to Settings, Privacy, Location Services, Unjabbed; and on Android, by going to Settings, Unjabbed App, Permissions, Location.
                        </TextComponent>
                    </li>
                    <li>
                        <TextComponent variant="h5">
                            Feedback/Support. If you provide us feedback or contact customer support, we collect your name and e-mail address and possibly other Personal Data (e.g. IP address), as well as any other content that you send to us in order to reply and address any issue. If you contact customer support, we also collect and retain certain technical diagnostic data, such as your phone model. We may keep records of our communication with you, including any complaints we receive from you about other users (and from other users about you).
                        </TextComponent>
                    </li>
                    <li>
                        <TextComponent variant="h5">
                            Private Messages and Safety Reviews. We do not routinely have people read every private message. To help keep Unjabbed safe, we may use limited automated safety checks and may review the messages and account information that are relevant to a member report or a credible safety concern. This may include investigating suspected scams, requests for money, solicitation, harassment, fraud, or other breaches of our Terms of Use and Community Guidelines.
                        </TextComponent>
                    </li>
                </ul>
            </Column>
            <Column className="gap-5">
                <TextComponent variant="h5">
                    GENERAL DATA PROTECTION REGULATION (GDPR)
                </TextComponent>
                <TextComponent variant="h5">
                    We are a Data Controller of your information.
                </TextComponent>
                <TextComponent variant="h5">
                    For legal basis we are collecting and using the personal information described in this Privacy Policy depends on the Personal Information we collect and the specific context in which we collect the information:
                </TextComponent>
                <ul>
                    <li>
                        <TextComponent variant="h5">
                            We need to perform a contract with you.
                        </TextComponent>
                    </li>
                    <li>
                        <TextComponent variant="h5">
                            You have given us permission to do so.
                        </TextComponent>
                    </li>
                    <li>
                        <TextComponent variant="h5">
                            Processing your personal information is in we legitimate interests.
                        </TextComponent>
                    </li>
                    <li>
                        <TextComponent variant="h5">
                            We need to comply with the law.
                        </TextComponent>
                    </li>
                    <li>
                        <TextComponent variant="h5">
                            We will retain your personal information only for as long as is necessary for the purposes set out in this Privacy Policy. We will retain and use your information to the extent necessary to comply with our legal obligations, resolve disputes, and enforce our policies.
                        </TextComponent>
                    </li>
                </ul>
                <TextComponent variant="h5">
                    If you are a resident of the European Economic Area (EEA), you have certain data protection rights. If you wish to be informed what Personal Information, we hold about you and if you want it to be removed from our systems, please contact us.
                </TextComponent>
            </Column>
            <Column className="gap-5">
                <TextComponent variant="h5">
                    You are entitled to the following rights under applicable laws:
                </TextComponent>
                <ul>
                    <li>
                        <TextComponent variant="h5">
                            The right to access: you may at any time request to access your personal data. Upon request, we will provide a copy of your personal data in a commonly used electronic form.
                        </TextComponent>
                    </li>
                    <li>
                        <TextComponent variant="h5">
                            The right to rectification: you are entitled to obtain rectification of inaccurate personal data and to have incomplete personal data completed.
                        </TextComponent>
                    </li>
                    <li>
                        <TextComponent variant="h5">
                            The right to erase: under certain circumstances (including processing on the basis of your consent), you may request us to delete your User Data. Please note that this right is not unconditional. Therefore, an attempt to invoke the right might not lead to an action from us.
                        </TextComponent>
                    </li>
                    <li>
                        <TextComponent variant="h5">
                            The right to object: to certain processing activities conducted by us in relation to your personal data, such as our processing of your personal data based on our legitimate interest. The right to object also applies to the processing of your personal data for direct marketing purposes.
                        </TextComponent>
                    </li>
                    <li>
                        <TextComponent variant="h5">
                            The right to data portability: you are entitled to receive your personal data (or have your personal data directly transmitted to another data controller) in a structured, commonly used and machine-readable format.
                        </TextComponent>
                    </li>
                </ul>
            </Column>
            <Column className="gap-5">
                <TextComponent variant="h5">
                    CALIFORNIA CONSUMER PRIVACY ACT (CCPA)
                </TextComponent>
                <TextComponent variant="h5">
                    If you are a California resident, you are entitled to learn what data we collect about you, ask to delete your data and not to sell (share) it. To exercise your data protection rights, you can make certain requests and ask us:
                </TextComponent>
                <ul>
                    <li>
                        <TextComponent variant="h5">
                            What personal information we have about you. If you make this request, we will return to you:
                        </TextComponent>
                        <ul>
                            <li>
                                <TextComponent variant="h5">
                                    The categories of personal information we have collected about you.
                                </TextComponent>
                            </li>
                            <li>
                                <TextComponent variant="h5">
                                    The categories of sources from which we collect your personal information.
                                </TextComponent>
                            </li>
                            <li>
                                <TextComponent variant="h5">
                                    The business or commercial purpose for collecting or selling your personal information.
                                </TextComponent>
                            </li>
                            <li>
                                <TextComponent variant="h5">
                                    The categories of third parties with whom we share personal information.
                                </TextComponent>
                            </li>
                            <li>
                                <TextComponent variant="h5">
                                    The specific pieces of personal information we have collected about you.
                                </TextComponent>
                            </li>
                            <li>
                                <TextComponent variant="h5">
                                    A list of categories of personal information that we have sold, along with the category of any other company we sold it to. If we have not sold your personal information, we will inform you of that fact.
                                </TextComponent>
                            </li>
                            <li>
                                <TextComponent variant="h5">
                                    A list of categories of personal information that we have disclosed for a business purpose, along with the category of any other company we shared it with.
                                </TextComponent>
                            </li>
                            <li>
                                <TextComponent variant="h5">
                                    Please note, you are entitled to ask us to provide you with this information up to two times in a rolling twelve-month period. When you make this request, the information provided may be limited to the personal information we collected about you in the previous 12 months.
                                </TextComponent>
                            </li>
                        </ul>
                    </li>
                    <br />
                    <li>
                        <TextComponent variant="h5">
                            To delete your personal information. If you make this request, we will delete the personal information we hold about you as of the date of your request from our records and direct any service providers to do the same. In some cases, deletion may be accomplished through de-identification of the information. If you choose to delete your personal information, you may not be able to use certain functions that require your personal information to operate.
                        </TextComponent>
                    </li>
                    <li>
                        <TextComponent variant="h5">
                            To stop selling your personal information. We don’t sell or rent your personal information to any third parties for any purpose. We do not sell your personal information for monetary consideration. However, under some circumstances, a transfer of personal information to a third party, or within our family of companies, without monetary consideration may be considered a “sale” under California law. You are the only owner of your Personal Data and can request disclosure or deletion at any time.
                        </TextComponent>
                    </li>
                    <li>
                        <TextComponent variant="h5">
                            If you submit a request to stop selling your personal information, we will stop making such transfers.
                        </TextComponent>
                    </li>
                </ul>
                <TextComponent variant="h5">
                    Please note, if you ask us to delete or stop selling your data, it may impact your experience with us, and you may not be able to participate in certain programs or membership services which require the usage of your personal information to function. But in no circumstances, we will discriminate against you for exercising your rights.
                </TextComponent>
                <TextComponent variant="h5">
                    To exercise your California data protection rights described above, please send your request(s) by email: <a href="mailto:accounts@unjabbed.app" className="text-primary">accounts@unjabbed.app</a>
                </TextComponent>
                <TextComponent variant="h5">
                    Your data protection rights, described above, are covered by the CCPA, short for the California Consumer Privacy Act. To find out more, visit the official California Legislative Information website.
                </TextComponent>
            </Column>
            <Column className="gap-5">
                <TextComponent variant="h5">
                    PERMISSIONS REQUIRED
                </TextComponent>
                <ul>
                    <li>
                        <TextComponent variant="h5">
                            INTERNET
                        </TextComponent>
                    </li>
                    <li>
                        <TextComponent variant="h5">
                            NOTIFICATION
                        </TextComponent>
                    </li>
                    <li>
                        <TextComponent variant="h5">
                            CAMERA
                        </TextComponent>
                    </li>
                    <li>
                        <TextComponent variant="h5">
                            LOCATION
                        </TextComponent>
                    </li>
                    <li>
                        <TextComponent variant="h5">
                            STORAGE
                        </TextComponent>
                    </li>
                    <li>
                        <TextComponent variant="h5">
                            Link to the privacy policy of third-party service providers used by the app
                        </TextComponent>
                    </li>
                </ul>
                <ul>
                    <li>
                        <TextComponent variant="h5">
                            Apple App Store Services
                        </TextComponent>
                    </li>
                    <li>
                        <TextComponent variant="h5">
                            Google Play Services
                        </TextComponent>
                    </li>
                    <li>
                        <TextComponent variant="h5">
                            LOG DATA
                        </TextComponent>
                    </li>
                </ul>
                <TextComponent variant="h5">
                    We want to inform you that whenever you use our Service, in case of an error in the app, we collect data and information (through third-party products) on your phone called Log Data. This Log Data may include information such as your device Internet Protocol (“IP”) address, device name, operating system version, the configuration of the app when utilizing our Service, the time and date of your use of the Service, and other statistics.
                </TextComponent>
            </Column>
            <Column className="gap-5">
                <TextComponent variant="h5">
                    YOUR PERSONAL DATA
                </TextComponent>
                <TextComponent variant="h5">
                    We are using strong backend for our Unjabbed App. In backend, all the content will be store. All Data will remain safe and secure. No any single information/data will send to the anywhere.
                </TextComponent>
            </Column>
            <Column className="gap-5">
                <TextComponent variant="h5">
                    SECURITY
                </TextComponent>
                <TextComponent variant="h5">
                    We value your trust in providing us your Personal Information, thus we are striving to use commercially acceptable means of protecting it. But remember that no method of transmission over the internet, or method of electronic storage is 100% secure and reliable, and we cannot guarantee its absolute security.
                </TextComponent>
            </Column>
            <Column className="gap-5">
                <TextComponent variant="h5">
                    USER CONTENT
                </TextComponent>
                <TextComponent variant="h5">
                    The Services may provide You to upload your own content on to Unjabbed App or take part in one to one conversations and discussions or other functionalities through which You may provide or upload content such as text, pictures, video and audio through the Services (“User Content”). You agree not to upload or provide any User Content that is: (a) libelous, defamatory, obscene, abusive, pornographic, threatening or represents an invasion of privacy; (b) infringing or misappropriating intellectual property or other rights of any third party; (c) illegal in any way or that advocates illegal activity; (d) contains any viruses or programming routines intended to damage, surreptitiously intercept or expropriate the Software, Services or any system, data or personal information; (e) false, misleading or inaccurate; or (f) an advertisement or solicitation of funds, goods, or services. Global 22 Pty Ltd will not be responsible or liable for any deletion, correction, destruction, damage, or loss of or to any User Content. Global 22 Pty Ltd is under no obligation to review any User Content for accuracy or potential liability. You represent and warrant that You own all right, title, and interest in and to any User Content that you make available and that You have sufficient rights to grant Global 22 Pty Ltd the rights included in the Agreement. However, Global 22 Pty Ltd retains the right to remove illegal User Content or Existing Content in conflict with the Agreement if inaction may lead to criminal or tort liability.
                </TextComponent>
            </Column>
            <Column className="gap-5">
                <TextComponent variant="h5">
                    PAYMENT TERMS
                </TextComponent>
                <TextComponent variant="h5">
                    We may provide paid products and/or services within the Service. In that case, we use third-party services for payment processing (e.g. payment processors).
                </TextComponent>
                <TextComponent variant="h5">
                    We will not store or collect your payment card details. That information is provided directly to our third-party payment processors whose use of your personal information is governed by their Privacy Policy.
                </TextComponent>
            </Column>
            <Column className="gap-5">
                <TextComponent variant="h5">
                    The payment processors we work with are:
                </TextComponent>
                <TextComponent variant="h5">
                    Apple Store In-App Payments <a href="https://www.apple.com/legal/privacy/en-ww/" className="text-primary">https://www.apple.com/legal/privacy/en-ww/</a>
                </TextComponent>
            </Column>
            <Column className="gap-5">
                <TextComponent variant="h5">
                    Google Play In-App Payments
                </TextComponent>
                <TextComponent variant="h5">
                    Their Privacy Policy can be viewed at <a href="https://www.google.com/policies/privacy/" className="text-primary">https://www.google.com/policies/privacy/</a>
                </TextComponent>
            </Column>
            <Column className="gap-5">
                <TextComponent variant="h5">
                    SERVICE PROVIDERS
                </TextComponent>
                <TextComponent variant="h5">
                    We may employ third-party companies and individuals due to the following reasons:
                </TextComponent>
                <ul>
                    <li>
                        <TextComponent variant="h5">
                            To facilitate our Service;
                        </TextComponent>
                    </li>
                    <li>
                        <TextComponent variant="h5">
                            To provide the Service on our behalf;
                        </TextComponent>
                    </li>
                    <li>
                        <TextComponent variant="h5">
                            To perform Service-related services; or
                        </TextComponent>
                    </li>
                    <li>
                        <TextComponent variant="h5">
                            To assist us in analyzing how our Service is used.
                        </TextComponent>
                    </li>
                    <li>
                        <TextComponent variant="h5">
                            We want to inform users of this Service that these third parties have access to your Personal Information. The reason is to perform the tasks assigned to them on our behalf. However, they are obligated not to disclose or use the information for any other purpose.
                        </TextComponent>
                    </li>
                </ul>
            </Column>
            <Column className="gap-5">
                <TextComponent variant="h5">
                    UPDATES OR CHANGES TO OUR PRIVACY POLICY
                </TextComponent>
                <TextComponent variant="h5">
                    Occasionally, we may change or update this Privacy Policy to allow us to use or share your previously collected Personal Data for other purposes. If we would use your Personal Data in a manner materially different from that stated at the time of the collection, we will provide you with a notice on our Website and in our Unjabbed Mobile Application indicating that the Privacy Policy has been changed or updated and request you to agree with the updated or changed Privacy Policy.
                </TextComponent>
            </Column>
            <Column className="gap-5">
                <TextComponent variant="h5">
                    CONTACT US
                </TextComponent>
                <a href="mailto:accounts@unjabbed.app" className="text-primary">accounts@unjabbed.app</a>
            </Column>
        </Column>
    );
};
